module.exports = __webpack_public_path__ + "static/media/02n.fea72597.png";